import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import { getColorObjectsStyleByRecord } from 'PDF/helpers/documentStyle';

import { ProfilesTableRow } from './ProfilesTableRow';
import { IProfilesTableItem } from './types';

interface IProfileTableProps {
  items: IProfilesTableItem[];
  isExamplePage: boolean;
  heading?: React.ReactNode;
}

const colorIndexes = {
  green: [12, 32],
  blue: [5, 2],
  red: [5, 2],
  blueGreen: [0, 2],
  blueRed: [1, 2],
  blueYellow: [5, 2],
};

export const ProfilesTable = ({ items, isExamplePage, heading }: IProfileTableProps) => {
  const [nameColor, personnelInfoColor] = getColorObjectsStyleByRecord(colorIndexes, ['color', 'backgroundColor']);
  const [firstItem, ...otherItems] = items;
  const { t } = useTranslation();
  const nameInfo = {
    heading: isExamplePage ? '' : t('pdfPages.mappings.managementAndOrganization.nameSurname'),
    info: 'Camila Davis',
  };
  const itemTable = ({ photo, name, surname, rows }: IProfilesTableItem, index?: number) => (
    <View key={index} style={styles.wrap}>
      <View>
        {photo && <Image src={photo} style={styles.img} />}
        <View fixed style={{ width: '175px' }}></View>
      </View>
      <View style={styles.column}>
        <View style={[styles.nameWrap, personnelInfoColor]}>
          <View style={styles.ceil}>
            <Text style={styles.heading}>{nameInfo.heading}</Text>
            <Text style={[styles.name, nameColor]}>{`${name} ${surname}`}</Text>
          </View>
        </View>
        {rows.map((info, index) => (
          <ProfilesTableRow key={index} heading={info.heading} info={info.info} />
        ))}
      </View>
    </View>
  );

  return (
    <>
      <View>
        {heading}
        {itemTable(firstItem)}
      </View>
      {otherItems.map((item, index) => (
        <Fragment key={index}>
          <View minPresenceAhead={140} />
          {itemTable(item, index)}
        </Fragment>
      ))}
    </>
  );
};

const styles = StyleSheet.create({
  wrap: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 30,
  },
  img: {
    width: '159px',
    height: '136px',
    marginRight: '16px',
    objectFit: 'cover',
  },
  nameWrap: {
    padding: '10px 0 10px 0',
    height: '58px',
    width: '348px',
  },
  ceil: {
    height: '40px',
    borderTop: '0.5px solid #fff',
    borderBottom: '0.5px solid #fff',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  heading: {
    fontFamily: 'Noto',
    fontWeight: 600,
    color: '#000',
    fontSize: '8px',
    minWidth: '84px',
    marginRight: '20px',
    marginLeft: '2px',
  },
  name: {
    fontFamily: 'Noto',
    fontWeight: 600,
    fontSize: '9px',
    paddingRight: '10px',
    width: '100%',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
  },
});
